import React, { ReactNode } from 'react';
import { ActionItem } from '../../types';
import VideoMeta from './templates/LessonVideoTemplate/VideoMeta';
import LessonButtonComponent from './templates/StaticContentTemplate/LessonButton';
import LessonNavigation from './LessonNavigation';
import styles from './lesson-display.module.css';
import { Navigation } from '../../lib/getNavigationMap';
import { saveProgress } from '../../lib/learnClient';

type ActionItemContainerProps = {
  children: ReactNode;
  actionItem: ActionItem;
  navigation: Navigation;
  onUpdate: any;
  urlPrefix: string;
};

type HeaderProps = {
  title: string;
  icon: string | null | undefined;
};

const STATIC_CONTENT = 'static-content';
const RESPONSE_QUESTION = 'response-question';
const SURVEY = 'survey';

const CLASS_NAME_MAP: { [k: string]: string } = {
  'static-content': 'ActionItemContainer ActionItemContainer--static',
  'lesson-video': 'ActionItemContainer ActionItemContainer--video',
  'response-question': 'ActionItemContainer ActionItemContainer--question',
  survey: 'ActionItemContainer ActionItemContainer--survey',
};

function Header({ title, icon }: HeaderProps) {
  return (
    <div className={styles.header}>
      {icon && <img src={icon} alt="" className={styles.icon} />}
      <h2 className={styles.title}>{title}</h2>
    </div>
  );
}

function ActionItemContainer({
  children,
  actionItem,
  navigation,
  onUpdate,
}: ActionItemContainerProps) {
  const {
    id,
    title,
    icon,
    body,
    template,
    course_id,
    lesson_id,
    video_title,
    subtitle,
    summary,
    personality_list,
  } = actionItem;

  const actionItemsWithTitle = [STATIC_CONTENT, RESPONSE_QUESTION];
  const actionItemsOnCard = [STATIC_CONTENT, RESPONSE_QUESTION, SURVEY];
  const showTitle = actionItemsWithTitle.includes(template);
  const hasButtons = body?.buttons;

  const classNames = actionItemsOnCard.includes(template)
    ? `${styles.actionItemCard} ${CLASS_NAME_MAP[template]}`
    : CLASS_NAME_MAP[template];

  return (
    <div className={classNames}>
      {showTitle ? <Header title={title} icon={icon} /> : null}
      {children}

      {hasButtons ? (
        <LessonButtonComponent
          actionItem={actionItem}
          onComplete={() => {
            onUpdate(actionItem);
            saveProgress({
              course_id,
              lesson_id,
              action_id: id,
              data: { complete: true },
              template,
            });
          }}
        />
      ) : null}

      <LessonNavigation navigation={navigation} item={actionItem} />

      {template === 'lesson-video' && (
        <VideoMeta
          title={video_title}
          subtitle={subtitle as string}
          summary={summary}
          personalities={personality_list}
          courseId={course_id}
        />
      )}
    </div>
  );
}

export default ActionItemContainer;
